import * as React from 'react';
import type { SVGProps } from 'react';
const UploadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75 20.959V23.7715C3.75 24.5174 4.04632 25.2328 4.57376 25.7602C5.10121 26.2877 5.81658 26.584 6.5625 26.584H23.4375C24.1834 26.584 24.8988 26.2877 25.4262 25.7602C25.9537 25.2328 26.25 24.5174 26.25 23.7715V20.959M9.375 9.70898L15 4.08398M15 4.08398L20.625 9.70898M15 4.08398V20.959"
      stroke="#9099A5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default UploadIcon;
